import React from "react";
import { SIDES, SIDE_COLOR, getArchetype, useArchetypeLibrary } from "../../lib/archetypes";
import { archetypeIcon } from "./ArchetypeIdentityCard";

// "Offense: Primary Ball Handler / Movement Shooter · Defense: Point of Attack" — descriptions on hover/tap.
export function ArchetypeLine({ archetypes, compact = false, legacy = null, testid = "archetype-line" }) {
  const lib = useArchetypeLibrary();
  if (!lib.ready) return null;
  const sides = SIDES.map(([side, label]) => {
    const sel = archetypes?.[side];
    const p = getArchetype(sel?.primary), s = getArchetype(sel?.secondary);
    const fallback = !p && legacy?.[side];
    return { side, label, p, s, fallback };
  }).filter(x => x.p || x.fallback);
  if (!sides.length) return null;
  return (
    <div className={`flex flex-wrap items-center ${compact ? "gap-x-3 gap-y-1" : "gap-x-5 gap-y-2"}`} data-testid={testid}>
      {sides.map(({ side, label, p, s, fallback }, i) => {
        const Icon = archetypeIcon(p, side);
        return (
          <React.Fragment key={side}>
            {i > 0 && <span className="text-[#575757]">·</span>}
            <span className="inline-flex items-center gap-1.5" data-testid={`${testid}-${side}`}>
              <span className="w-6 h-6 rounded-full flex items-center justify-center border shrink-0" style={{ borderColor: `${SIDE_COLOR[side]}66`, background: `${SIDE_COLOR[side]}1a` }}><Icon className="w-3.5 h-3.5" style={{ color: SIDE_COLOR[side] }} /></span>
              <span className="text-[9px] uppercase tracking-[0.3em] text-[#757575]">{label}:</span>
              {p ? (
                <span className="text-sm text-white font-semibold">
                  <span title={p.description || undefined} className="cursor-help border-b border-dotted border-white/20">{p.name}</span>
                  {s && <> <span className="text-[#757575] font-normal">/</span> <span title={s.description || undefined} className="cursor-help border-b border-dotted border-white/20">{s.name}</span></>}
                </span>
              ) : (
                <span className="text-sm text-[#c0c0c0]" title="From the earlier Archetype & Role picker">{fallback}</span>
              )}
            </span>
          </React.Fragment>
        );
      })}
    </div>
  );
}
